import React from 'react';
import { CustomButton, CustomInputSelect } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  IUsersProfileModuleOptionDatatable,
  UsersProfileModuleOptionDatatableMeta,
} from './UsersProfileModuleOptionDatatableHandlerMeta';

export default function UsersProfileModuleOptionDatatableHandler() {
  const editUsersModal = React.useRef<any>(null);
  const deleteUsersModal = React.useRef<any>(null);

  const data: IUsersProfileModuleOptionDatatable[] = [
    {
      idOption: 'HPX',
      labelOption: 'MULTIPIXPAC V6',
      idMenuParent: 'ADMIN',
      access: 'true',
      insert: 'true',
      update: 'true',
      delete: 'true',
    },
  ];

  return (
    <>
      <CC.Box w="full">
        <CustomReactTable
          w="full"
          data={data}
          columns={UsersProfileModuleOptionDatatableMeta.columns()}
        />
        <CC.Flex justifyContent="flex-end" my="2">
          <CustomButton>Enregistrer</CustomButton>
        </CC.Flex>
      </CC.Box>

      <CustomAppModal
        title="Editer Le Status des utilisateurs"
        ref={editUsersModal}
        actionBtnText="Editer"
        actionBtnClick={() => editUsersModal?.current?.onClose()}
      >
        <CustomFormControl label="Status">
          <CustomInputSelect
            meta={{
              name: 'status',
              options: [
                { label: 'Actif', value: 'active' },
                { label: 'Vérouillé', value: 'lock' },
              ],
            }}
          />
        </CustomFormControl>
      </CustomAppModal>

      <CustomAppModal
        title="Confirmer la suppression"
        ref={deleteUsersModal}
        actionBtnText="Supprimer"
        actionBtnClick={() => deleteUsersModal?.current?.onClose()}
      >
        <CC.Text>Voulez-vous vraiment supprimer ?</CC.Text>
      </CustomAppModal>
    </>
  );
}
